import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.querySelector('.wp-block-gallery');
  const flkty = new Flickity(elem, {
    adaptiveHeight: true,
    wrapAround: true,
  });

  window.flkty = flkty;
});
